<template>
  <div>
    <v-card
      rounded="lg"
      color="grey lighten-4"
      class="pa-3 hoverable-card"
    >
      <v-row
        no-gutters
        align="center"
      >
        <v-col
          v-if="orderable"
          cols="auto"
          class="pr-3"
        >
          <v-icon
            small
            class="handle"
            style="cursor: move"
          >
            far fa-grip-lines
          </v-icon>
        </v-col>
        <v-col>
          <v-row
            no-gutters
            align="center"
            :style="[ editable ? { minHeight: '30px' } : undefined ]"
          >
            <v-col>
              <div
                class="font-weight-medium"
                :class="{ 'caption': dense }"
              >
                {{ $t("training_builder.exercises.pause") }} - <strong>{{ item.params.DURATION }}s</strong>
              </div>
            </v-col>
            <v-col
              v-if="editable"
              cols="auto"
              class="show-hover"
            >
              <v-btn
                text
                color="grey darken-2"
                small
                outlined
                class="text-none"
                @click="dialog = true"
              >
                <v-icon
                  x-small
                  left
                >
                  far fa-pen
                </v-icon>
                {{ $t('training_builder.button.parameters') }}
              </v-btn>
              <v-btn
                text
                color="error"
                small
                @click="$emit('delete')"
              >
                <v-icon x-small>
                  far fa-trash
                </v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-card>

    <card-dialog
      v-model="dialog"
      max-width="600px"
      :title="$t('training_builder.configure_pause.dialog.header')"
    >
      <v-card-text
        class="pa-6"
      >
        <v-text-field
          v-model="params.DURATION"
          outlined
          :label="$t('training_builder.text_input.pause_duration.title')"
          type="number"
        >
          <template v-slot:append>
            s
          </template>
        </v-text-field>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          color="primary"
          @click="saveParams()"
        >
          {{ $t('training_builder.button.save') }}
        </v-btn>
      </v-card-actions>
    </card-dialog>
  </div>
</template>
<script>
import CardDialog from '@/components/helpers/CardDialog.vue'
import { cloneDeep } from 'lodash'

export default {
  name: 'PauseSelectedCard',
  components: { CardDialog },
  props: {
    item: {
      type: Object,
      required: true
    },
    dense: {
      type: Boolean,
      default: false
    },
    orderable: {
      type: Boolean,
      default: true
    },
    editable: {
      type: Boolean,
      default: true
    },
    feedbackAllowed: {
      type: Boolean,
      default: false
    },
    showMedia: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      dialog: false,
      params: {
        DURATION: 30
      }
    }
  },

  computed: {
  },

  created() {
    if (!this.item.params) {
      this.item.params = { ...this.params }
    } else if (this.item.params) {
      this.params = { ...this.item.params }
    }

    if (this.item.configureParams) {
      this.dialog = true
      this.item.configureParams = false
    }
  },

  methods: {
    saveParams() {
      this.item.params = cloneDeep(this.params)

      this.dialog = false
    }
  }
}
</script>

<style>
/*.drop-placeholder:before {
  width: 100%;
  color: #9a9a9a;
  font-size: 16px;
  content: "Drop exercise here";
  display: flex;
  align-items: center;
  justify-content: center;
}*/
</style>
